import { defineMessages } from 'react-intl';

export default defineMessages({
  feeOneTimeOption: {
    id: 'app.modules.services.fees.types.oneTime',
    defaultMessage: 'One time',
  },
  feeRegularOption: {
    id: 'app.modules.services.fees.types.regular',
    defaultMessage: 'Regular',
  },
  feeNameMinLengthError: {
    id: 'app.modules.services.fees.title.minError',
    defaultMessage: 'Title should be at least 2 symbols',
  },
  feeNameMaxLengthError: {
    id: 'app.modules.services.fees.title.maxError',
    defaultMessage: 'Title should be at less than 100 symbols',
  },
  viewFeePageTitle: {
    id: 'app.modules.services.fees.feePage.title.view',
    defaultMessage: 'View Fee',
  },
  editFeePageTitle: {
    id: 'app.modules.services.fees.feePage.title.edit',
    defaultMessage: 'Edit Fee',
  },
  newFeePageTitle: {
    id: 'app.modules.services.fees.feePage.title.create',
    defaultMessage: 'New Fee',
  },
});
